"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6683],{

/***/ 1035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96964);
/* harmony import */ var _layout_Push__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23516);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38945);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  width: 100%;\n  ",
        ";\n  bottom: 0;\n  padding: ",
        "px;\n  ",
        "\n  z-index: 9;\n\n  @media (max-height: 340px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var bottomButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject(), _styles_css__WEBPACK_IMPORTED_MODULE_1__/* .responsiveMaxWidth */ .S8, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, (0,_styles_css__WEBPACK_IMPORTED_MODULE_1__/* .safeArea */ .BI)("bottom", "padding", chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium));
var BottomButton = function(_param) {
    var className = _param.className, _push = _param.push, push = _push === void 0 ? false : _push, children = _param.children, _pushSize = _param.pushSize, pushSize = _pushSize === void 0 ? _layout_Push__WEBPACK_IMPORTED_MODULE_2__/* .PushSize.bottomButton */ .z.bottomButton : _pushSize, props = _objectWithoutProperties(_param, [
        "className",
        "push",
        "children",
        "pushSize"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
        children: [
            push && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_layout_Push__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                bottom: true,
                size: pushSize
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                className: className,
                css: bottomButtonCSS,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpreadProps(_objectSpread({}, props), {
                    children: children
                }))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomButton);


/***/ }),

/***/ 58761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Header; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/react-intersection-observer-virtual-e594021c28/0/cache/react-intersection-observer-npm-9.5.3-5bc82a81dc-2281912a9f.zip/node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(74001);
// EXTERNAL MODULE: ./hooks/useModal.ts
var useModal = __webpack_require__(48294);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(9150);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(82740);
// EXTERNAL MODULE: ./.yarn/__virtual__/react-query-virtual-8f3bd3534b/0/cache/react-query-npm-3.39.3-72b2a93edf-d2de6a0992.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(54909);
// EXTERNAL MODULE: ./stores/useOverlayStore.ts
var useOverlayStore = __webpack_require__(46092);
// EXTERNAL MODULE: ./utils/localStorage.ts
var localStorage = __webpack_require__(48163);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
// EXTERNAL MODULE: ./components/common/Modal.tsx
var Modal = __webpack_require__(59585);
;// CONCATENATED MODULE: ./components/modal/MockDatePickerModal.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  line-height: 1.3;\n\n  h5 {\n    margin-bottom: ",
        "px;\n  }\n\n  input {\n    height: 50px;\n    width: 100%;\n    margin-bottom: ",
        "px;\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  > p {\n    font-size: ",
        "px;\n    white-space: pre-line;\n    background-color: ",
        ";\n    color: ",
        ";\n    padding: ",
        "px;\n    border-radius: ",
        "px;\n  }\n  .qualification {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: ",
        "px;\n\n    p {\n      font-size: ",
        "px;\n      text-align: left;\n\n      small {\n        font-size: ",
        "px;\n        color: ",
        ";\n        display: block;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var mockDatePickerModalCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject(), dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.medium */.Ki.medium, theme.var.white, theme.var.black, dist_esm/* FontSizes.xsmall */.TS.xsmall, theme.colors.main50, theme.var.gray800, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Radius.medium */.wU.medium, dist_esm/* Spacing.small */.Ki.small, dist_esm/* FontSizes.small */.TS.small, dist_esm/* FontSizes.xsmall */.TS.xsmall, theme.var.gray600);
};
var parsingDate = function(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");
    var hours = String(date.getHours()).padStart(2, "0");
    var minutes = String(date.getMinutes()).padStart(2, "0");
    var formattedDate = "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hours, ":").concat(minutes);
    return formattedDate;
};
var MockDatePickerModal = function(_param) {
    var props = _extends({}, _param);
    var t = (0,esm/* useTranslation */.$G)().t;
    var queryClient = (0,es.useQueryClient)();
    var closeOverlay = (0,useOverlayStore/* useCloseOverlay */.E)();
    var formattedDate = parsingDate(new Date());
    var ref = (0,react.useState)(formattedDate), selectedDate = ref[0], setSelectedDate = ref[1];
    var ref1 = (0,react.useState)(new Date().toString()), kstDate = ref1[0], setKstDate = ref1[1];
    var ref2 = (0,react.useState)(null), currentTime = ref2[0], setCurrentTime = ref2[1];
    (0,react.useEffect)(function() {
        var ref;
        var settingDate = (ref = (0,misc/* getSettingDate */.jl)()) === null || ref === void 0 ? void 0 : ref.date;
        setCurrentTime(settingDate !== null && settingDate !== void 0 ? settingDate : new Date());
    }, []);
    var handleClickSetting = function() {
        localStorage/* ParsedStorage.setItem */.f.setItem("mockDate", {
            date: kstDate
        });
        setCurrentTime(kstDate);
        queryClient.invalidateQueries();
    };
    var handleDateChange = function(e) {
        var selectedDate = e.target.value;
        var dateInKST = new Date(selectedDate).toString();
        var parsedDate = parsingDate(new Date(selectedDate));
        setKstDate(dateInKST);
        setSelectedDate(parsedDate);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* default */.ZP, _objectSpreadProps(_objectSpread({}, props), {
        title: t("개발 Date Picker"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            css: mockDatePickerModalCSS,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("input", {
                    type: "datetime-local",
                    onChange: handleDateChange,
                    value: selectedDate,
                    max: "2029-06-20T20:06",
                    min: "2016-02-20T02:20"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                        children: [
                            "지금 날짜 : ",
                            currentTime === null || currentTime === void 0 ? void 0 : currentTime.toString()
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalButton */.mH, {
                    onClick: function() {
                        handleClickSetting();
                        closeOverlay();
                    },
                    text: t("설정")
                })
            ]
        })
    }));
};
/* harmony default export */ var modal_MockDatePickerModal = (MockDatePickerModal);

// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
// EXTERNAL MODULE: ./utils/webview.ts
var webview = __webpack_require__(81946);
// EXTERNAL MODULE: ./components/layout/Push.tsx
var Push = __webpack_require__(23516);
;// CONCATENATED MODULE: ./components/layout/Header.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function Header_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function Header_templateObject() {
    var data = Header_taggedTemplateLiteral([
        "\n            background-color: ",
        ";\n          "
    ]);
    Header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = Header_taggedTemplateLiteral([
        "\n            background-color: ",
        ";\n          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = Header_taggedTemplateLiteral([
        "\n      position: fixed;\n      ",
        ";\n      top: 0;\n      z-index: 9;\n      width: 100%;\n      transition: background-color 0.1s ease-out;\n      ",
        ";\n      ",
        "\n\n      .has-sidebar & {\n        ",
        " {\n          border-left: 1px solid ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = Header_taggedTemplateLiteral([
        "\n        border-bottom: 1px solid ",
        ";\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = Header_taggedTemplateLiteral([
        "\n          opacity: 0;\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = Header_taggedTemplateLiteral([
        "\n      position: relative;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding-left: ",
        "px;\n      padding-right: ",
        "px;\n      height: ",
        "px;\n\n      ",
        "\n\n      h4 {\n        position: absolute;\n        left: 50%;\n        transform: translateX(-50%);\n        line-height: ",
        "px;\n        text-align: center;\n        max-width: 70%;\n\n        ",
        "\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = Header_taggedTemplateLiteral([
        "\n  margin-right: auto;\n\n  > * + * {\n    margin-right: ",
        "px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = Header_taggedTemplateLiteral([
        "\n  margin-left: auto;\n\n  > * + * {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = Header_taggedTemplateLiteral([
        "\n        top: ",
        "px;\n      "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = Header_taggedTemplateLiteral([
        "\n        top: ",
        ";\n      "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = Header_taggedTemplateLiteral([
        "\n  position: absolute;\n  ",
        "\n  width: 1px;\n  height: 1px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}














var headerWrapperCSS = function(isTransparent, backgroundColor) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject2(), css/* responsiveMaxWidth */.S8, isTransparent ? (0,css/* linearGradient */.bC)("top") : !!backgroundColor ? (0,emotion_react_browser_esm.css)(Header_templateObject(), backgroundColor) : (0,emotion_react_browser_esm.css)(_templateObject1(), theme.var.white), (0,css/* safeArea */.BI)("top"), css/* media.tablet */.BC.tablet, theme.var.gray200);
    };
};
var headerCSS = function(isTransparent, hideBorder) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject5(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium, css/* HEADER_HEIGHT */.Mz, !isTransparent && !hideBorder && (0,emotion_react_browser_esm.css)(_templateObject3(), theme.border.light), css/* HEADER_HEIGHT */.Mz, isTransparent && (0,emotion_react_browser_esm.css)(_templateObject4()));
    };
};
var leftCSS = (0,emotion_react_browser_esm.css)(_templateObject6(), dist_esm/* Spacing.xsmall */.Ki.xsmall);
var rightCSS = (0,emotion_react_browser_esm.css)(_templateObject7(), dist_esm/* Spacing.xsmall */.Ki.xsmall);
var transparentCSS = function(fadeInAt) {
    return (0,emotion_react_browser_esm.css)(_templateObject10(), typeof fadeInAt === "number" ? (0,emotion_react_browser_esm.css)(_templateObject8(), fadeInAt) : (0,emotion_react_browser_esm.css)(_templateObject9(), fadeInAt));
};
var Header = function(param) {
    var title = param.title, _push = param.push, push = _push === void 0 ? true : _push, left = param.left, right = param.right, _transparent = param.transparent, transparent = _transparent === void 0 ? false : _transparent, transparentFadeInAt = param.transparentFadeInAt, _hideBackButton = param.hideBackButton, hideBackButton = _hideBackButton === void 0 ? false : _hideBackButton, _hideBorder = param.hideBorder, hideBorder = _hideBorder === void 0 ? false : _hideBorder, onBack = param.onBack, _isShowDevIcon = param.isShowDevIcon, isShowDevIcon = _isShowDevIcon === void 0 ? true : _isShowDevIcon, backgroundColor = param.backgroundColor, iconColor = param.iconColor, prev = param.prev;
    var t = (0,esm/* useTranslation */.$G)().t;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var router = (0,next_router.useRouter)();
    var safeGoBack = (0,webview/* useWebView */.B9)().safeGoBack;
    var ref = (0,react.useState)(transparent), isTransparent = ref[0], setTransparent = ref[1];
    var ref1 = _slicedToArray((0,useModal/* useModal */.d)("mock-date-picker-modal"), 2), isShowDatePicker = ref1[0], ref2 = ref1[1], openModal = ref2.open, closeModal = ref2.close;
    var ref3 = (0,react_intersection_observer/* useInView */.YD)({
        initialInView: transparent
    }), ref4 = ref3.ref, inView = ref3.inView;
    var color = isTransparent ? theme.true.white : !!iconColor ? iconColor : theme.var.black;
    var isDev = !(0,misc/* isEnv */.h5)("production");
    var goBack = function() {
        safeGoBack(prev);
    };
    (0,react.useEffect)(function() {
        setTransparent(inView);
    }, [
        router,
        inView
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("header", {
                css: headerWrapperCSS(isTransparent, backgroundColor),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    css: headerCSS(isTransparent, hideBorder),
                    children: [
                        !hideBackButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                            className: "icon-btn",
                            "aria-label": t("뒤로가기"),
                            onClick: onBack !== null && onBack !== void 0 ? onBack : goBack,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                icon: icon/* ArrowLeft */.Xd,
                                color: color
                            })
                        }),
                        left && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            css: leftCSS,
                            children: left(color)
                        }),
                        isDev && isShowDevIcon && !hideBackButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            style: {
                                display: "flex"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                onClick: openModal,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                    icon: icon/* Setting */.pE
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h4", {
                            className: "ellipsis",
                            children: title
                        }),
                        right && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            css: rightCSS,
                            children: right(color)
                        })
                    ]
                })
            }),
            transparent && transparentFadeInAt && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: transparentCSS(transparentFadeInAt),
                ref: ref4
            }),
            push && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Push/* default */.Z, {
                top: true,
                size: Push/* PushSize.header */.z.header
            }),
            isDev && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(modal_MockDatePickerModal, {
                open: isShowDatePicker,
                onClose: closeModal
            })
        ]
    });
};
/* harmony default export */ var layout_Header = (Header);


/***/ })

}]);